import { CONTACT, HOME, IMG, SERVICE_PAGES, TOURS_PAGE, FLEET, TOURS, TESTIMONIALS, EXTRA_BLOCKS } from "../mock";

// Every editable website text/photo: [key, label, type, object, prop]
const svc = (k, name) => [
  [`svc.${k}.title`, `${name} – big title`, "text", SERVICE_PAGES[k], "title"],
  [`svc.${k}.sub`, `${name} – intro text`, "textarea", SERVICE_PAGES[k], "sub"],
  [`svc.${k}.image`, `${name} – top photo`, "image", SERVICE_PAGES[k], "image"],
];
export const GROUPS = [
  ["Business details", [
    ["contact.phone", "Phone (as shown)", "text", CONTACT, "phone"],
    ["contact.phoneRaw", "Phone for calls & WhatsApp (digits only, with country code, e.g. 306983400353)", "text", CONTACT, "phoneRaw"],
    ["contact.email", "Email", "text", CONTACT, "email"],
  ]],
  ["Homepage", [
    ["home.heroTitle1", "Big title – line 1", "text", HOME, "heroTitle1"],
    ["home.heroTitle2", "Big title – line 2 (gold)", "text", HOME, "heroTitle2"],
    ["home.heroSub", "Intro text", "textarea", HOME, "heroSub"],
    ["home.heroImage", "Top photo", "image", IMG, "hero"],
    ["home.heroAlt", "Top photo description (read by Google)", "text", HOME, "heroAlt"],
    ["home.reviewsTitle", "Reviews title", "text", HOME, "reviewsTitle"],
    ["home.ctaTitle", "Bottom banner title", "text", HOME, "ctaTitle"],
    ["home.ctaSub", "Bottom banner text", "text", HOME, "ctaSub"],
  ]],
  ["Airport Transfers page", svc("airport", "Airport")],
  ["Port Transfers page", svc("port", "Port")],
  ["Private Transfers page", svc("private", "Private")],
  ["Chauffeur page", svc("chauffeur", "Chauffeur")],
  ["Tours page", [
    ["tours.title", "Big title", "text", TOURS_PAGE, "title"],
    ["tours.sub", "Intro text", "textarea", TOURS_PAGE, "sub"],
    ["tours.image", "Top photo", "image", IMG, "tours"],
    ...TOURS.flatMap((t, i) => [
      [`tour.${t.slug}.title`, `Tour ${i + 1} – name`, "text", t, "title"],
      [`tour.${t.slug}.desc`, `Tour ${i + 1} – description`, "textarea", t, "desc"],
      [`tour.${t.slug}.image`, `Tour ${i + 1} – photo`, "image", t, "image"],
    ]),
  ]],
  ["Fleet", FLEET.flatMap((v) => [
    [`fleet.${v.id}.model`, `${v.name} – model text`, "text", v, "model"],
    [`fleet.${v.id}.image`, `${v.name} – photo`, "image", v, "image"],
  ])],
];
export const ABOUT_PAGES = [["/airport-transfers", "Airport Transfers"], ["/transfers/port", "Port Transfers"], ["/transfers/private", "Private Transfers"], ["/chauffeur", "Chauffeur"], ["/tours", "Tours"]];
export const BLOCK_PAGES = [["home", "Homepage"], ["airport", "Airport Transfers"], ["port", "Port Transfers"], ["private", "Private Transfers"], ["chauffeur", "Chauffeur"], ["tours", "Tours"], ["fleet", "Fleet"], ["about", "About Us"]];

const FIELDS = GROUPS.flatMap(([, f]) => f);
export const DEFAULTS = Object.fromEntries(FIELDS.map(([k, , , o, p]) => [k, o[p]]));
export const DEFAULT_REVIEWS = TESTIMONIALS.map((t) => ({ ...t }));
const CACHE = "aloha_site_content";

export const applyContent = (data = {}) => {
  FIELDS.forEach(([k, , , o, p]) => { o[p] = data[k] ?? DEFAULTS[k]; });
  CONTACT.whatsapp = `https://wa.me/${CONTACT.phoneRaw}?text=Hello%20Aloha%20Corfu%20Transfers%2C%20I%20would%20like%20information%20about%20a%20transfer.`;
  TESTIMONIALS.splice(0, TESTIMONIALS.length, ...(Array.isArray(data.reviews) ? data.reviews : DEFAULT_REVIEWS));
  Object.keys(EXTRA_BLOCKS).forEach((k) => delete EXTRA_BLOCKS[k]);
  Object.assign(EXTRA_BLOCKS, data.blocks || {}, { __about: data.about || {} });
};

export const loadCachedContent = () => {
  try { const c = JSON.parse(localStorage.getItem(CACHE) || "null"); if (c) applyContent(c); return c; } catch { return null; }
};
export const cacheContent = (data) => { try { localStorage.setItem(CACHE, JSON.stringify(data)); } catch { /* ignore */ } };
